import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { getNotifications, readAllNotifications } from '../../store/actions/notificationAction';
import { setUnreadCount } from '../../store/slices/notificationSlice';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();
  // const [selectedTab, setSelectedTab] = useState('all');

  const { notifications, notificationLoading, unreadCount } = useSelector((state) => state.notification);
  const { notificationsContent } = useSelector((state) => state.content);
  const markReadTimerRef = useRef(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(notificationsContent, key, isArabic);
  };

  useEffect(() => {
    getData();
    return () => clearTimeout(markReadTimerRef.current);
  }, []);

  const getData = () => {
    dispatch(
      getNotifications((response) => {
        if (response?.result?.unreadCount > 0) {
          markReadTimerRef.current = setTimeout(() => {
            dispatch(
              readAllNotifications(() => {
                dispatch(setUnreadCount(0));
                dispatch(getNotifications(() => { }, false));
              }),
            );
          }, 2000);
        }
      }),
    );
  };

  // const onPressTab = (key) => setSelectedTab(key);

  const getGroupLabel = (date) => {
    const parsedDate = dayjs(date);
    if (parsedDate.isSame(dayjs(), 'day')) return getContentKey('today');
    if (parsedDate.isSame(dayjs().subtract(1, 'day'), 'day')) return getContentKey('yesterday');
    return parsedDate.locale(isArabic ? 'ar' : 'en').format('D MMMM YYYY');
  };

  const items = notifications?.items ?? [];
  // const filteredItems = items.filter((item) =>
  //   selectedTab === 'unread' ? !item?.isRead : true,
  // );

  const groupedNotifications = [];
  items.forEach((item) => {
    const label = getGroupLabel(item?.createdDate);
    const itemDate = dayjs(item?.createdDate).locale(isArabic ? 'ar' : 'en');
    const mappedItem = {
      id: item?.id,
      title: isArabic ? item?.titleAr : item?.titleEn,
      description: isArabic ? item?.bodyAr : item?.bodyEn,
      time: itemDate.isSame(dayjs(), 'day')
        ? `${getContentKey('today')} . ${itemDate.format('hh:mm A')}`
        : `${itemDate.format('M/D/YYYY')} · ${itemDate.format('hh:mm A')}`,
      isRead: item?.isRead,
    };
    const existingGroup = groupedNotifications.find((notificationGroup) => notificationGroup?.label === label);
    if (existingGroup) {
      existingGroup?.items?.push(mappedItem);
    } else {
      groupedNotifications.push({ label, items: [mappedItem] });
    }
  });

  return {
    TextWeight,
    isArabic,
    navigate,
    // selectedTab,
    // onPressTab,
    groupedNotifications,
    notificationLoading,
    unreadCount,
    getContentKey,
  };
};
